import Button from 'components/actions/Button';
import ButtonWithTooltip from 'components/actions/ButtonWithTooltip';
import type React from 'react';

import './_styles.scss';

interface Props {
    onConfirmLabel: string | React.JSX.Element;
    onCancel(): void;
    isValid?: boolean;
    isLoading?: boolean;
}

const FormDialogFooter = ({ onConfirmLabel, onCancel, isValid, isLoading }: Props) => (
    <div className='FormDialogFooter'>
        <div className='FormDialogFooter__border' />
        <div className='FormDialogFooter__buttons'>
            <Button data-testid='form-dialog-footer-cancel-button' onClick={onCancel}>
                Cancel
            </Button>
            <ButtonWithTooltip
                label={onConfirmLabel}
                tooltip='Complete the mandatory fields to continue'
                isDisabled={!isValid}
                type='submit'
                isLoading={isLoading}
            />
        </div>
    </div>
);

export default FormDialogFooter;
